import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { Workplace } from './models/workplace/Workplace';
import { StatusType } from './models/workplace/StatusType';
import { sharedStorage } from 'src/common/storage/storage';

export interface WorkplaceStore {
  workplaces: Workplace[] | null;
  selectedWorkplace: Workplace | null;
  availableStatuses: StatusType[];
  setWorkplaces: (workplaces: Workplace[] | null) => void;
  updateWorkplacesStatus: (customerId: string, statusId: string) => void;
  setSelectedWorkplace: (selectedWorkplace: Workplace | null) => void;
  setAvailableStatuses: (availableStatuses: StatusType[]) => void;
}

export const useWaWorkplaceStore = create<WorkplaceStore>()(
  persist<WorkplaceStore>(
    (set) => ({
      workplaces: null,
      selectedWorkplace: null,
      availableStatuses: [],
      setWorkplaces: (workplaces) => set({ workplaces }),
      updateWorkplacesStatus: (customerId, statusId) =>
        set((state) => {
          const currentSite =
            state.selectedWorkplace?.customerId === customerId
              ? {
                  ...state.selectedWorkplace,
                  details: {
                    ...state.selectedWorkplace.details,
                    statusId,
                  },
                }
              : state.selectedWorkplace;
          return { selectedWorkplace: currentSite };
        }),
      setSelectedWorkplace: (selectedWorkplace) => set({ selectedWorkplace }),
      setAvailableStatuses: (availableStatuses) => set({ availableStatuses }),
    }),
    {
      name: 'wa-workplace',
      storage: createJSONStorage(() => sharedStorage),
      partialize: (state) =>
        ({
          selectedWorkplace: state.selectedWorkplace,
          availableStatuses: state.availableStatuses,
        }) as WorkplaceStore,
    }
  )
);
